/* eslint-disable */
import { CancelButton, ModalButton } from '../styles'
import styled from 'styled-components'

const TrainButton = styled(ModalButton)`
  min-width: 75px;
  max-width: 75px;
`

export { TrainButton, CancelButton, ModalButton }
